import APIController from '../core-api-controller';

export const fetchLeadsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/leads${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchOrdersApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/orders${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const syncLeadsApi = (data = {}) => {
  const path = `${APIController.endpointApi}/leads/sync`;
  return APIController.postCallback(path, data);
};

//Detail page Apis

export const fetchLeadDetailApi = (leadId = '') => {
  const path = `${APIController.endpointApi}/leads/${leadId}`;
  return APIController.getApiCallback(path);
};

export const fetchCommunicationSettingsApi = (leadId = '') => {
  const path = `${APIController.endpointApi}/leads/${leadId}/communication_settings`;
  return APIController.getApiCallback(path);
};

export const fetchLeadOrdersApi = (leadId = '', params = {}) => {
  const path = `${APIController.endpointApi}/leads/${leadId}/orders`;
  return APIController.getApiCallback(path, params);
};

export const fetchLeadLabOrdersApi = (leadId = '', params) => {
  const path = `${APIController.endpointApi}/leads/${leadId}/lab_orders`;
  return APIController.getApiCallback(path, params);
};

export const fetchLeadProductsApi = (leadId = '') => {
  const path = `${APIController.endpointApi}/leads/${leadId}/product_variants`;
  return APIController.getApiCallback(path);
};

export const fetchLeadUntrackedCasesApi = (leadId = '') => {
  const path = `${APIController.endpointApi}/leads/${leadId}/untrack_cases`;
  return APIController.getApiCallback(path);
};

export const fetchOrderDetailsApi = (orderId = '') => {
  const path = `${APIController.endpointApi}/orders/${orderId}`;
  return APIController.getApiCallback(path);
};

export const fetchSubscriptionDetailsApi = (subscriptionId = '') => {
  const path = `${APIController.endpointApi}/subscriptions/${subscriptionId}`;
  return APIController.getApiCallback(path);
};

export const updateLeadStatusApi = (leadId = '', data = {}) => {
  const path = `${APIController.endpointApi}/leads/${leadId}`;
  return APIController.putCallback(path, data);
};

export const mergeLeadsApi = (data, leadId = '') => {
  const path = `${APIController.endpointApi}/leads/${leadId}/merge_lead`;
  return APIController.postCallback(path, data);
};

export const createLeadSupportTicket = (data, leadId = '') => {
  const path = `${APIController.endpointApi}/leads/${leadId}/open_ticket`;
  return APIController.postCallback(path, data);
};

export const resolveLeadSupportTicket = (data, leadId = '', paramsStr) => {
  const path = `${APIController.endpointApi}/leads/${leadId}/resolve_ticket${paramsStr ? paramsStr : ''}`;
  return APIController.postCallback(path, data);
};

export const changeTicketAssignee = (ticketId = '', data) => {
  const path = `${APIController.endpointApi}/tickets/${ticketId}/assign_ticket`;
  return APIController.putCallback(path, data);
};

export const fetchAvailableAssigns = (id = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/tickets/${id}/fetch_available_assigns`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchLeadTicketsApi = (id, paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/leads/${id}/list_tickets${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchCaseNotesApi = (caseId) => {
  const path = `${APIController.endpointApi}/cases/${caseId}/notes`;
  return APIController.getApiCallback(path);
};

export const markAsDeliveredApi = (caseId, body) => {
  const path = `${APIController.endpointApi}/cases/${caseId}/mark_as_delivered`;
  return APIController.postCallback(path, body);
};

export const fetchCasePrescriptionsApi = (caseId = '') => {
  const path = `${APIController.endpointApi}/cases/${caseId}/prescriptions`;
  return APIController.getApiCallback(path);
};

export const fetchCaseTrackingsApi = (caseId = '') => {
  const path = `${APIController.endpointApi}/cases/${caseId}/trackings`;
  return APIController.getApiCallback(path);
};

export const buildPaymentRequestApi = (leadId, body) => {
  const path = `${APIController.endpointApi}/leads/${leadId}/build_payment_request`;
  return APIController.postCallback(path, body);
};

//High Level Chats APIs

export const fetchChats = ({ leadId = '', paramsStr = '' }) => {
  const path = `${APIController.endpointApi}/high_level/leads/${leadId}/messages${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path);
};

export const sendChatMessage = ({ id = '', data = {} }) => {
  const path = `${APIController.endpointApi}/high_level/leads/${id}/send_message`;
  return APIController.postCallback(path, data);
};

export const sendMdiChatMessage = ({ id = '', data = {} }) => {
  const path = `${APIController.endpointApi}/mdi/leads/${id}/send_message`;
  return APIController.postCallback(path, data);
};

export const sendTelegramdChatMessage = ({ leadId = '', data = {} }) => {
  const path = `${APIController.endpointApi}/telegramd/leads/${leadId}/send_message`;
  return APIController.postCallback(path, data);
};

export const fetchAttachments = ({ leadId = '', paramsStr = '' }, responseType) => {
  const path = `${APIController.endpointApi}/high_level/leads/${leadId}/message_attachments${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, null, null, responseType);
};

//Messages
export const fetchMdiMessages = ({ id = '', paramsStr = '' }) => {
  const path = `${APIController.endpointApi}/mdi/leads/${id}/messages${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path);
};

export const uploadMdiAttachmentApi = ({ id = '', data = {} }) => {
  const path = `${APIController.endpointApi}/mdi/leads/${id}/upload_file`;
  return APIController.postCallback(path, data);
};

export const deleteMdiAttachmentApi = ({ id = '', paramsStr = '' }) => {
  const path = `${APIController.endpointApi}/mdi/leads/${id}/remove_file${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path);
};

export const fetchTelegramdMessagesApi = ({ id = '', paramsStr = '' }) => {
  const path = `${APIController.endpointApi}/telegramd/leads/${id}/messages${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path);
};

export const fetchGethealthieConversationsApi = (leadId) => {
  const path = `${APIController.endpointApi}/gethealthie/leads/${leadId}/conversations`;
  return APIController.getApiCallback(path);
};

export const fetchGethealthieMessagesApi = ({ id = '', paramsStr = '' }) => {
  const path = `${APIController.endpointApi}/gethealthie/conversations/${id}/messages${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path);
};

export const fetchGethealthieMessageDetailsApi = ({ id = '', paramsStr = '' }) => {
  const path = `${APIController.endpointApi}/gethealthie/conversations/${id}/message_details${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path);
};

export const sendGethealthieMessage = ({ id = '', data = {} }) => {
  const path = `${APIController.endpointApi}/gethealthie/conversations/${id}/send_message`;
  return APIController.postCallback(path, data);
};

//Tracking State
export const fetchTrackingState = ({ id = '', paramsStr = '' }) => {
  const path = `${APIController.endpointApi}/pharmacy_trackings/${id}/fetch_current_state${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path);
};

//Message Templates
export const fetchMessageTemplates = () => {
  const path = `${APIController.endpointApi}/leads/fetch_templates`;
  return APIController.getApiCallback(path);
};

export const sendMessageTemplate = ({ leadId = '', data = {} }) => {
  const path = `${APIController.endpointApi}/leads/${leadId}/send_via_template`;
  return APIController.postCallback(path, data);
};

//lab documents
export const fetchLeadLabDocumentsApi = (leadId) => {
  const path = `${APIController.endpointApi}/leads/${leadId}/lab_documents`;
  return APIController.getApiCallback(path);
};

export const uploadLabDocumentsApi = (leadId = '', data = {}) => {
  const path = `${APIController.endpointApi}/leads/${leadId}/upload_lab_documents`;
  return APIController.postCallback(path, data);
};

export const getGenericDataApi = ({ path, paramsStr = '?per_page=200' }) => {
  const completePath = `${APIController.endpointApi}/${path}${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(completePath);
};
